import { render, staticRenderFns } from "./list copy 2.vue?vue&type=template&id=32c14b18"
import script from "./list copy 2.vue?vue&type=script&lang=js"
export * from "./list copy 2.vue?vue&type=script&lang=js"
import style0 from "./list copy 2.vue?vue&type=style&index=0&id=32c14b18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports